/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React,{useState,useCallback,useEffect,useContext} from 'react'
import SlidingPane from 'react-sliding-pane'
import "react-sliding-pane/dist/react-sliding-pane.css";
import CrudModal from './CrudModal';
import './style.css'
import { distributorService } from '../../service/distributor.service';
import ListUser from './ListUser';
import { ShimmerTable } from 'react-shimmer-effects';
import HeaderContext from '../../Components/Context/HeaderContext';
import EmptyPage from '../../Components/EmptyPage';

function MangeAssistantUsers() {
    const {
        SetErrorMessage,
        setcolorValue,
        setisPopup
    } = useContext(HeaderContext);
    const handleError = (message)=>{
        setloading(false);
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }
    const [open, setopen] = useState(false);
    const [list, setlist] = useState([]);
    const [loading, setloading] = useState(true);
    const [editData, seteditData] = useState({})
    const handleFetch = useCallback(
        async() => {
            const users = await distributorService.GetUserList();
            if(!users.error && users.data.data!== null){
                setlist(users?.data?.data);
                setloading(false);
            }else{
                setloading(false)

            }

        },
        [],
    )
    const EmptyConetnt = ({setopen})=>(
        <>
            <p className="text-[#555259] font-normal text-xl pt-2 mx-auto text-center">
                It seems you haven't added an assistant user yet!
            </p>
            <button onClick={()=>setopen(true)} className="bg-[#555259] w-[270px] h-[53px] rounded-lg mt-10 text-[#FFFFFF] font-semibold text-lg" data-bs-toggle="modal" data-bs-target="#addAssistantUser">
                Add User
            </button>
        </>
    )
    useEffect(() => {
        handleFetch()
    }, [handleFetch])
    
    return (
        <div className='md:mx-[100px] mx-4'>
            <div className="flex sm:flex-row flex-col sm:items-center items-start justify-between sm:flex-nowrap flex-wrap pt-9">
                <p className="text-[#555259] font-normal text-xl mr-5">User Management</p>
                <div className="self-end">
                    <button 
                        onClick={() =>{
                            seteditData({});
                            setopen(true);
                            setisPopup(true)

                        } }
                        className="bg-[#555259] rounded-lg font-semibold text-[#FFFFFF] text-xs9 w-[130px] h-9 sm:pt-0 mt-4"data-bs-toggle="modal" data-bs-target="#addAssistantUser">
                        Add User
                    </button>
                </div>
            </div>
            <SlidingPane
                from="right"
                isOpen={open}
                width="501px"
                className="modal-z-index"
                hideHeader
                onRequestClose={() => setopen(false)}

            >
                <CrudModal setopen={setopen} handleError={handleError} open={open} handleFetch={handleFetch} editData={editData} seteditData={seteditData} isUpdate={Object.keys(editData).length > 0}/>

            </SlidingPane>
            <>{
                loading ? <div className='pt-7'><ShimmerTable className="pt-7" row={10} col={5} /></div>:<>{list.length === 0 ? <EmptyPage
                    Content={<EmptyConetnt setopen={setopen}/>} /> : <ListUser handleFetch={handleFetch} handleError={handleError} list={list} setopen={setopen} seteditData={seteditData} editData={editData} />}</>
            }
            </>
        </div>
    )
}

export default MangeAssistantUsers